import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import classes from './profile.module.css';
import Header from '../../components/standartComponents/header';

const Profile = ({ authUser }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('profile');
  const [activeModal, setActiveModal] = useState(null);
  
  const [subStatus, setSubStatus] = useState('active'); // active, cancelled
  const [supportSent, setSupportSent] = useState(false);

  const openMod = (id) => setActiveModal(id);
  const closeMod = () => setActiveModal(null);

  const confirmCancel = () => {
    setSubStatus('cancelled');
    closeMod();
  };

  const submitSupport = () => {
    setSupportSent(true);
  };

  const logout = () => {
    closeMod();
    navigate('/');
  };

  return (
    <>
      <Header authUser={authUser} />
      <div className={classes.main}>
      {/* SIDEBAR */}
      <div className={classes.sidebar}>
        <button className={`${classes.sbItem} ${activeTab === 'profile' ? classes.on : ''}`} onClick={() => setActiveTab('profile')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>Мій профіль
        </button>
        <button className={`${classes.sbItem} ${activeTab === 'sub' ? classes.on : ''}`} onClick={() => setActiveTab('sub')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>Підписка
        </button>
        <button className={`${classes.sbItem} ${activeTab === 'support' ? classes.on : ''}`} onClick={() => setActiveTab('support')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Підтримка
        </button>
        <div className={classes.sbSep}></div>
        <button className={`${classes.sbItem} ${classes.logout}`} onClick={() => openMod('logout')}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg>Вийти
        </button>
      </div>

      {/* CONTENT */}
      <div className={classes.content}>
        <h1 className={classes.pageTitle}>Персональний кабінет</h1>
        <p className={classes.pageSub}>Керуйте профілем, підпискою та зверненнями до підтримки.</p>

        {/* PROFILE TAB */}
        <div className={`${classes.section} ${activeTab === 'profile' ? classes.active : ''}`}>
          <div className={classes.card}>
            <div className={classes.profileHeader}>
              <div className={classes.profileAv}>А</div>
              <div><div className={classes.profileName}>Аліна</div><div className={classes.profileEmail}>alina@gmail.com</div></div>
            </div>
            <div className={classes.infoGrid}>
              <div className={classes.infoItem}><div className={classes.infoLabel}>Ім'я</div><div className={classes.infoValue}>Аліна</div></div>
              <div className={classes.infoItem}><div className={classes.infoLabel}>Email</div><div className={classes.infoValue}>alina@gmail.com</div></div>
              <div className={classes.infoItem}><div className={classes.infoLabel}>Мова інтерфейсу</div><div className={classes.infoValue}>Українська</div></div>
              <div className={classes.infoItem}><div className={classes.infoLabel}>Рівень англійської</div><div className={classes.infoValue}>A0</div></div>
              <div className={`${classes.infoItem} ${classes.infoItemFull}`}><div className={classes.infoLabel}>Дата реєстрації</div><div className={classes.infoValue}>19 травня 2026</div></div>
            </div>
            <div className={classes.btnRow}>
              <button className={`${classes.btn} ${classes.btnP}`} onClick={() => openMod('editProfile')}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z"/></svg>Редагувати профіль</button>
              <button className={`${classes.btn} ${classes.btnG}`} onClick={() => openMod('changePass')}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Змінити пароль</button>
            </div>
          </div>
        </div>

        {/* SUBSCRIPTION TAB */}
        <div className={`${classes.section} ${activeTab === 'sub' ? classes.active : ''}`}>
          <div className={classes.card}>
            <div className={classes.cardTitle}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>Підписка</div>
            
            {subStatus === 'active' ? (
              <div className={`${classes.subBadge} ${classes.active}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Активна</div>
            ) : (
              <div className={`${classes.subBadge} ${classes.cancelled}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Скасована</div>
            )}
            
            <div className={classes.subPlan}>Premium</div>
            <div className={classes.subGrid}>
              <div className={classes.subItem}><div className={classes.subLabel}>{subStatus === 'active' ? 'Наступне списання' : 'Доступ до'}</div><div className={classes.subValue}>19 червня 2026</div></div>
              <div className={classes.subItem}><div className={classes.subLabel}>Сума</div><div className={classes.subValue}>299 грн / місяць</div></div>
              <div className={classes.subItem}><div className={classes.subLabel}>Спосіб оплати</div><div className={classes.subValue}>Visa **** 1234</div></div>
              <div className={classes.subItem}><div className={classes.subLabel}>Тариф</div><div className={classes.subValue}>Premium · Щомісячно</div></div>
            </div>
            
            <div className={classes.btnRow}>
              <button className={`${classes.btn} ${classes.btnP}`} onClick={() => navigate('/pricing')}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m18 15-6-6-6 6"/></svg>Оновити тариф</button>
              {subStatus === 'active' && (
                <button className={`${classes.btn} ${classes.btnR}`} onClick={() => openMod('cancelSub')}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>Скасувати підписку</button>
              )}
            </div>
          </div>
        </div>

        {/* SUPPORT TAB */}
        <div className={`${classes.section} ${activeTab === 'support' ? classes.active : ''}`}>
          <div className={classes.card}>
            <div className={classes.cardTitle}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>Підтримка</div>
            <p style={{fontSize: '14px', color: 'var(--text-2)', marginBottom: '16px'}}>Напишіть нам, якщо маєте питання щодо уроків, підписки або технічної проблеми.</p>
            <div className={classes.supportEmail}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>Повідомлення буде надіслано на: support@ailingua.com</div>
            
            {!supportSent ? (
              <div>
                <div className={classes.fg}><label className={classes.fl}>Тема звернення</label><select className={classes.fi}><option>Питання щодо підписки</option><option>Проблема з оплатою</option><option>Проблема з уроком</option><option>Технічна проблема</option><option>Інше</option></select></div>
                <div className={classes.fg}><label className={classes.fl}>Повідомлення</label><textarea className={classes.fi} placeholder="Опишіть ваше питання або проблему…"></textarea></div>
                <button className={`${classes.btn} ${classes.btnP}`} onClick={submitSupport}>Надіслати<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg></button>
              </div>
            ) : (
              <div className={`${classes.successBox} ${classes.show}`}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                <div className={classes.st}>Дякуємо!</div>
                <div className={classes.ss}>Ми отримали ваше звернення і відповімо на вашу пошту.</div>
              </div>
            )}
          </div>
        </div>

      </div>

      {/* MODALS */}
      {/* Edit Profile */}
      <div className={`${classes.ov} ${activeModal === 'editProfile' ? classes.show : ''}`} onClick={closeMod}>
        <div className={classes.mod} onClick={e => e.stopPropagation()}>
          <div className={classes.modT}>Редагувати профіль</div>
          <div className={classes.modS}>Оновіть ваші персональні дані.</div>
          <div className={classes.fg}><label className={classes.fl}>Ім'я</label><input className={classes.fi} defaultValue="Аліна" /></div>
          <div className={classes.fg}><label className={classes.fl}>Email</label><input className={classes.fi} defaultValue="alina@gmail.com" /></div>
          <div className={classes.fg}>
            <label className={classes.fl}>Мова інтерфейсу</label>
            <select className={classes.fi} defaultValue="Українська">
              <option>Українська</option><option>English</option><option>Polski</option>
            </select>
          </div>
          <div className={classes.modBtns}>
            <button className={`${classes.btn} ${classes.btnG}`} onClick={closeMod}>Скасувати</button>
            <button className={`${classes.btn} ${classes.btnP}`} onClick={closeMod}>Зберегти</button>
          </div>
        </div>
      </div>

      {/* Change Password */}
      <div className={`${classes.ov} ${activeModal === 'changePass' ? classes.show : ''}`} onClick={closeMod}>
        <div className={classes.mod} onClick={e => e.stopPropagation()}>
          <div className={classes.modT}>Змінити пароль</div>
          <div className={classes.modS}>Введіть поточний і новий пароль.</div>
          <div className={classes.fg}><label className={classes.fl}>Поточний пароль</label><input className={classes.fi} type="password" placeholder="••••••••" /></div>
          <div className={classes.fg}><label className={classes.fl}>Новий пароль</label><input className={classes.fi} type="password" placeholder="••••••••" /></div>
          <div className={classes.fg}><label className={classes.fl}>Повторіть новий пароль</label><input className={classes.fi} type="password" placeholder="••••••••" /></div>
          <div className={classes.modBtns}>
            <button className={`${classes.btn} ${classes.btnG}`} onClick={closeMod}>Скасувати</button>
            <button className={`${classes.btn} ${classes.btnP}`} onClick={closeMod}>Оновити пароль</button>
          </div>
        </div>
      </div>

      {/* Cancel Sub */}
      <div className={`${classes.ov} ${activeModal === 'cancelSub' ? classes.show : ''}`} onClick={closeMod}>
        <div className={classes.mod} onClick={e => e.stopPropagation()}>
          <div className={`${classes.modIcon} ${classes.modIconWarn}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/></svg></div>
          <div className={classes.modT}>Скасувати підписку?</div>
          <div className={classes.modS}>Ви збережете доступ до Premium до кінця оплаченого періоду. Ваш прогрес, курси та словник не будуть видалені.</div>
          <div className={classes.modBtns}>
            <button className={`${classes.btn} ${classes.btnP}`} onClick={closeMod}>Залишити підписку</button>
            <button className={`${classes.btn} ${classes.btnR}`} onClick={confirmCancel}>Скасувати підписку</button>
          </div>
        </div>
      </div>

      {/* Logout */}
      <div className={`${classes.ov} ${activeModal === 'logout' ? classes.show : ''}`} onClick={closeMod}>
        <div className={classes.mod} onClick={e => e.stopPropagation()}>
          <div className={`${classes.modIcon} ${classes.modIconDanger}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" x2="9" y1="12" y2="12"/></svg></div>
          <div className={classes.modT}>Вийти з акаунта?</div>
          <div className={classes.modS}>Ви зможете повернутися до навчання після повторного входу.</div>
          <div className={classes.modBtns}>
            <button className={`${classes.btn} ${classes.btnG}`} onClick={closeMod}>Скасувати</button>
            <button className={`${classes.btn} ${classes.btnR}`} onClick={logout}>Вийти</button>
          </div>
        </div>
      </div>
      
      </div>
    </>
  );
};

export default Profile;
